<div class="w-100 row">
  <div class="col-sm-12 col-md-4 row">
    <h4 class="col"><strong>{{ 'content.sic' | translate }}:</strong></h4>
    <div class="col">{{ getSic() }}</div>
  </div>
  <div class="col-sm-12 col-md-4 row">
    <h4 class="col"><strong>{{ 'content.sold-since-date' | translate }}:</strong></h4>
    <div class="col">{{ soldSinceDate }}</div>
  </div>
  <div class="col-sm-12 col-md-4 row">
    <h4 class="col-7"><strong>{{ 'content.highest-credit-ever' | translate }}:</strong></h4>
    <div class="col-5">{{ highestCreditEver | async }}</div>
  </div>
</div>
<div class="w-100 col pt-4">
  <div class="d-none d-xl-flex w-100 row ps-4 pe-4">
    <h4 class="col ps-0 pe-0">{{ 'content.report-date' | translate }}</h4>
    <h4 class="col ps-0 pe-0">{{ 'content.comments' | translate }}</h4>
    <h4 class="col ps-0 pe-0">{{ 'content.total' | translate }}</h4>
    <h4 class="col ps-0 pe-0">{{ 'content.future' | translate }}</h4>
    <h4 class="col ps-0 pe-0">{{ 'content.current' | translate }}</h4>
    <h4 class="col ps-0 pe-0">{{ 'content.1st-period' | translate }}</h4>
    <h4 class="col ps-0 pe-0">{{ 'content.2nd-period' | translate }}</h4>
    <h4 class="col ps-0 pe-0">{{ 'content.3rd-period' | translate }}</h4>
    <h4 class="col ps-0 pe-0">{{ 'content.4th-period' | translate }}</h4>
  </div>
  @for (d of dets; track d) {
    <div class="w-100 row ps-4 pe-4">
      <div class="col pdf-reactor-5 ps-0 pe-0">
        <h4 class="d-xl-none">{{ 'content.report-date' | translate }}</h4>
        <div>{{ reformatDate(d.recordDate) }}</div>
      </div>
      <div class="col pdf-reactor-5 ps-0 pe-0">
        <h4 class="d-xl-none">{{ 'content.comments' | translate }}</h4>
        <div>{{ d.tradeDetComment }}</div>
      </div>
      <div class="w-100 d-block d-md-none"></div>
      <div class="col pdf-reactor-5 ps-0 pe-0">
        <h4 class="d-xl-none">{{ 'content.total' | translate }}</h4>
        <div>{{ getTotalOwing(d) | async }}</div>
      </div>
      <div class="col pdf-reactor-5 ps-0 pe-0">
        <h4 class="d-xl-none">{{ 'content.future' | translate }}</h4>
        <div>{{ i18nService.formatCurrency(d.futureReceivables) | async }}</div>
      </div>
      <div class="w-100 d-block d-md-none"></div>
      <div class="col pdf-reactor-5 ps-0 pe-0">
        <h4 class="d-xl-none">{{ 'content.current' | translate }}</h4>
        <div>{{ i18nService.formatCurrency(d.dueCurrent) | async }}</div>
      </div>
      <div class="w-100 d-none d-md-block d-xl-none"></div>
      <div class="col pdf-reactor-5 ps-0 pe-0">
        <h4 class="d-xl-none">{{ 'content.1st-period' | translate }}</h4>
        <div>{{ i18nService.formatCurrency(d.due30) | async }}</div>
      </div>
      <div class="w-100 d-block d-md-none"></div>
      <div class="col pdf-reactor-5 ps-0 pe-0">
        <h4 class="d-xl-none">{{ 'content.2nd-period' | translate }}</h4>
        <div>{{ i18nService.formatCurrency(d.due60) | async }}</div>
      </div>
      <div class="col pdf-reactor-5 ps-0 pe-0">
        <h4 class="d-xl-none">{{ 'content.3rd-period' | translate }}</h4>
        <div>{{ i18nService.formatCurrency(d.due90) | async }}</div>
      </div>
      <div class="w-100 d-block d-md-none"></div>
      <div class="col pdf-reactor-5 ps-0 pe-0">
        <h4 class="d-xl-none">{{ 'content.4th-period' | translate }}</h4>
        <div>{{ i18nService.formatCurrency(d.due120) | async }}</div>
      </div>
      <div class="col ps-0 pe-0 d-xl-none"></div>
    </div>
  }
</div>
